DigiTickets.PaymentPatterns = Object.freeze({
    SINGLE: 'SINGLE'
});
